/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemParentIdResponseSchema } from './itemParentIdResponseSchema';

export const listDocumentItemParentIdResponseSchema = z.object({
  get data() {
    return z.array(itemParentIdResponseSchema);
  },
  recordCount: z.int().nullish(),
});
